import apiService from '@/services/apiService';

const actions = {
  getNewUserPromos({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('new-user-promo/find-with-paging', payload)
        .then((response) => {
          commit('getNewUserPromos', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getNewUserPromo({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.get(`new-user-promo/${payload}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getDimension({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.get(`additional-info/dimension/${payload}`)
        .then((response) => {
          commit('getDimension', response.data.data);
          resolve(response.data.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getAdminhub({ commit }) {
    apiService.setHeader();
    apiService.get('additional-info/admin-hub')
      .then((response) => {
        commit('getAdminhub', response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  getDiscountType({ commit }) {
    apiService.post('/new-user-promo/user-discount-type')
      .then((response) => {
        commit('getDiscountType', response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  getAddon({ commit }) {
    apiService.setHeader();
    apiService.get('additional-info/add-on')
      .then((response) => {
        commit('getAddon', response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  getExtraPackaging({ commit }) {
    apiService.get('additional-info/extra-packaging')
      .then((response) => {
        commit('getExtraPackaging', response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  postNewUserPromo({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('new-user-promo', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putNewUserPromo({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`new-user-promo/${payload.id}`, payload.formData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getNewUserAvailability({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('new-user-promo/check-availability-before-create', payload)
        .then((response) => {
          resolve(response);
          commit('getNewUserAvailability', response.data.data);
        })
        .catch((error) => {
          reject(error);
          console.log(error);
        });
    });
  },
  getNewUserAvailabilityEdit({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('new-user-promo/check-availability-before-update', payload)
        .then((response) => {
          resolve(response);
          commit('getNewUserAvailability', response.data.data);
        })
        .catch((error) => {
          reject(error);
          console.log(error);
        });
    });
  },
  delNewUserPromo({ commit }, payload) {
    apiService.delete(`new-user-promo/${payload}`)
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  updateStatusNewUserPromos({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('new-user-promo/update-status', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

};

export default actions;
